import React from "react";
import { useState, createRef } from "react";
import { useParams } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import AddPlanForm from "./addPlan/AddPlanForm";
import "./DetailsTransitions.css";
import PlanStatement from "./statement/PlanStatement";
import AddIssueGroupForm from "./addIssueGroup/AddIssueGroupForm";


export default function PlanDetails() {
    
    let { planid } = useParams();

    const [showPlanStmt, setShowPlanStmt] = useState(true);
    const [showAddPlanForm, setShowAddPlanForm] = useState(false);
    const [showAddIssueGroup, setShowAddIssueGroup] = useState(false);

    const planStmtRef = createRef();
    const addPlanRef = createRef();
    const addIssueGroupRef = createRef();

    const planAddedHandler = (newPlan) => {
        if(newPlan)
        {
            setShowAddPlanForm(false);
            setShowAddIssueGroup(true);           
        }
        else
        {
            setShowAddPlanForm(false);
            setShowPlanStmt(true);
        }

    }

    const groupAddedHandler = (newGroup) => {

    }

    return (
        <div>
            <CSSTransition nodeRef={planStmtRef}
                timeout={500}
                classNames="item"
                in={showPlanStmt}
                unmountOnExit>
                <div>
                    <h3>Plan Details</h3>
                        <div>     
                            <div ref={planStmtRef}>
                                <PlanStatement planId={planid} />
                            </div> 
                        </div> 
                </div>
            </CSSTransition>
            <CSSTransition nodeRef={addPlanRef}
                timeout={500}
                classNames="item"
                in={showAddPlanForm}
                unmountOnExit>
                <div ref={addPlanRef}>
                    <AddPlanForm addPlanEventHandler={planAddedHandler} />
                </div>
            </CSSTransition>
            <CSSTransition nodeRef={addIssueGroupRef}
                timeout={500}
                classNames="item"
                in={showAddIssueGroup}
                unmountOnExit>
                <div ref={addIssueGroupRef}>
                    <AddIssueGroupForm planId={planid} addGroupSuccessHandler={groupAddedHandler} />
                </div>
            </CSSTransition>
        </div>


    );
}